export enum QueryKeys {
  Design = 'design',
  Template = 'template',
  Glyphs = 'glyphs',
  Thumbnails = 'thumbnails',
  Presentation = 'presentation',
  PresentationInvite = 'presentation-invite',
  CollaborationInvite = 'collaboration-invite',
  Threads = 'threads',
  ReadStatus = 'seen',
  BasicUserInfo = 'basic-user-info',
  Permission = 'permissions',
  UnsplashPhoto = 'unsplash-photo',
  Element = 'element',
  SuggestedTemplates = 'suggested-templates',
  SimilarElements = 'similar-elements',
  AiArtInfo = 'ai-art-info',
  FreepikIconInfo = 'freepik-icon-info',
  ProjectAssets = 'project-assets',
  LeftMenuAssets = 'left-menu-assets',
  ElementsOverview = 'elements-overview',
  GroupElements = 'group-elements',
  SearchElements = 'search-elements',
  SearchPhotos = 'search-photos',
  TrendingPhotos = 'trending-photos',
  SearchFreepik = 'search-freepik',
  TrendingFreepik = 'trending-freepik',
  SearchAiArt = 'search-ai-art',
  TrendingAiArt = 'trending-ai-art',
  SimilarElementsByImage = 'similar-elements-by-image',
  BookmarksElements = 'bookmarks-elements',
  RecentlyUsedElement = 'recently-used-element',
}
